import { motion } from "framer-motion";

export default function SeoText() {
  return (
    <section data-testid="seo-text-section" className="py-12 lg:py-16 border-t border-white/5">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.15 }}
          transition={{ duration: 0.6 }}
        >
          <h2 className="font-display font-bold uppercase text-2xl sm:text-3xl text-white">
            Konya Çekici ve Yol Yardımı Hizmeti
          </h2>
          <p className="text-sm text-slate-400 leading-relaxed mt-4">
            Konya Çekicim olarak Karatay, Selçuklu ve Meram başta olmak üzere Konya'nın tüm
            ilçelerinde oto çekici, oto kurtarma, akü takviye, lastik değişimi ve yakıt ikmali
            hizmeti veriyoruz. Aracınız yolda kaldığında bizi arayın; konumunuza en kısa sürede
            ulaşıp aracınızı güvenle taşıyalım. İl içi çekici ihtiyaçlarınızın yanında Konya'dan
            tüm Türkiye'ye şehirler arası araç taşıma hizmeti sunuyoruz. 7/24 açığız: gece,
            gündüz, hafta sonu ve resmi tatillerde de Konya çekici denince akla gelen ilk numara{" "}
            <a
              href="tel:+905392196017"
              data-testid="seo-text-call-link"
              className="text-brand font-semibold"
            >
              0539 219 60 17
            </a>
            .
          </p>
        </motion.div>
      </div>
    </section>
  );
}
